import React, { Component } from 'react';
import { connect} from "remx";

import authStore from "../../stores/auth";
import dataStore from "../../stores/data";
import broker from '../../utils/broker';

class Sidebar extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            data_pelanggan: [],
            data_kategori : [],
            id_kategori : null,
            nama_kategori : null,
            color_kategori: null,
        }
        this.setDataKategori = this.setDataKategori.bind(this);
    }

    getDataKategori(){
        broker.fetch.get(`/data/user/${this.props.user.id}/kategori`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                this.setState({data_kategori: data.data})
                // dataStore.setters.setDataKategori(data.data);
                if (!this.props.data_kategori_per.id_kategori) {
                    dataStore.setters.setDataKategoriPer({id_kategori : data.data[0].id, 
                                                        nama_kategori : data.data[0].nama_keterangan, 
                                                        color_kategori : data.data[0].color0
                    });  
                }

            } else {

            }
        }).catch(err => {
            
        });
    }

    componentDidMount(){
        // if (!this.props.data_kategori_per.id_kategori) {
        //     this.getDataKategori();
        // }
        this.getDataKategori();
    }


    setDataKategori(id, nama, color){
        dataStore.setters.setDataKategoriPer({id_kategori : id, nama_kategori :nama, color_kategori :color});  
    }

    render(){
        return(
            <React.Fragment>
                     <div className="filemgr-sidebar">
                        <div className="filemgr-sidebar-header">
                        <h6 align="center"><i className="fa fa-briefcase mg-r-10"></i>Kategori Pekerjaan</h6>
                        </div>
                        <div className="filemgr-sidebar-body">
                            <div className="pd-t-20 pd-b-10 pd-x-10">
                                {/* <label className="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10">My Drive</label> */}
                                <nav className="nav nav-sidebar tx-13">
                                {(this.state.data_kategori) &&
                                    this.state.data_kategori.map((data, i) => {
                                        return <a href="#" key={i} data-toggle="tab" className={"nav-link " +((this.props.data_kategori_per.id_kategori === data.id) ? ' active ' : '')} onClick={() => this.setDataKategori(data.id, data.nama_keterangan, data.color) }>
                                                    <i className="far fa-folder mg-r-10"></i> <span>{data.nama_keterangan.substring(0, 25) + (data.nama_keterangan.length > 25 ? '.....' : '')}</span>
                                                </a>})
                                }
                                </nav>
                            </div>
                        </div>
                    </div>
            </React.Fragment>
        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        kategori_id : dataStore.getters.getDataKategoriId(),
        form_view : dataStore.getters.getDataFormView(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
    }
}

export default connect(mapStateToProps)(Sidebar);